export const descriptions = [
  {
    id: "source1",
    heading: "FP2020 Progress Report",
    content: `<p>FP2020's <a href="http://progress.familyplanning2020.org/">Progress Report</a> (2017&ndash;2018) provides mCPR estimates for FP2020 countries.</p>`
  },
  {
    id: "source2",
    heading: "UN Population Division",
    content: `<p>Projections of mCPR and users for married and unmarried women were drawn from preliminary 2019 data.</p>
	  <p><a href="https://www.un.org/en/development/desa/population/theme/family-planning/cp_model.asp">UNPD Estimates and Projections of Family Planning Indicators 2019</a></p>`
  },
  {
    id: "source3",
    heading: "National Surveys",
    content: `<p>National household surveys including socioeconomic, health, and fertility surveys provide data on method mix.</p>
	  <p><a href="https://www.un.org/en/development/desa/population/publications/dataset/contraception/wcu2018.asp">UNPD World Contraceptive Use 2018</a></p>`
  },
  {
    id: "source4",
    heading: "Multiple Indicator Cluster Survey (MICS)",
    content: `<p>Supoorted by UNICEF, these household surveys provide data on method mix.</p>`
  },
  {
    id: "source5",
    heading: "Demographic and Health Surveys (DHS)",
    content: `<p>Supported by USAID, these <a href="https://dhsprogram.com/">household surveys</a> provide data on method mix, sector mix, and FP prices paid in the private sector (from select surveys).</p>`
  },
  {
    id: "source6",
    heading: "Performance Monitoring and Accountability 2020 (PMA2020)",
    content: `<p>Supported by Bill and Melinda Gates Foundation, household and facility surveys provide information on method mix and FP prices paid in the private sector.</p>
	  <p><a href="https://www.pma2020.org">PMA2020 Homepage</a></p>`
  },
  {
    id: "source7",
    heading: "Social Marketing Statistics",
    content: `<p><a href="https://www.dktinternational.org/contraceptive-social-marketing-statistics/">Contraceptive social marketing statistics</a> compiled by DKT on the volume of FP products distributed through social marketing provides information on private sector volumes.</p>`
  },
  {
    id: "source8",
    heading: `Marie Stopes International (MSI), Population Services International (PSI), and DKT International`,
    content: `<p>Program data on contraceptive commodities distributed and services provided by channel provide information on private sector volumes.</p>
	  <ul>
	  <li><a href="https://mariestopes.org/">MSI Homepage</a></li>
	  <li><a href="https://www.psi.org">PSI Homepage</a></li>
	  <li><a href="https://dktinternational.org/">DKT Homepage</a></li>
	  </ul>`
  },
  {
    id: "source9",
    heading: "IQVIA Retail Data",
    content: `<p>Data on private sector retail prices acquired for use in CGA2018.</p>`
  },
  {
    id: "source10",
    heading: "SHOPS Plus Private Sector Assessments",
    content: `<p><a href="https://www.shopsplusproject.org/technicalarea/private-health-sector-assessments">Private health sector assessment</a> surveys conducted by the SHOPS Plus project provide data on private sector retail prices.</p>`
  },
  {
    id: "source11",
    heading: "FP Watch",
    content: `<p>Retail outlet surveys conducted by PSI provide data on private sector retail prices.</p>
	  <p><a href="http://www.actwatch.info/projects/fpwatch">FP Watch Homepage</a></p>`
  },
  {
    id: "source12",
    heading: "Track20 M&E Officer Retail Surveys",
    content: `<p>Results from surveys conducted by Track20 M&E Officers provide data on prices charged at private facilities.</p>`
  },
  {
    id: "source13",
    heading: "Adding It Up Report",
    content: `<p>Guttmacher's flagship <a href="https://www.guttmacher.org/tags/adding-it">Adding it Up Report</a> contributes data on prices of FP commodities.</p>`
  },
  {
    id: "source14",
    heading: "Reproductive Health Interchange (RHI)",
    content: `<p><a href="https://www.unfpaprocurement.org/rhi-home">Online database</a> with data on contraceptive procurements from donors and implementing organizations.</p>`
  },
  {
    id: "source15",
    heading: "UNFPA External Procurement Reports",
    content: `<p>Annual reports published by UNFPA on donor and partner procurement of FP commodities.</p>`
  },
  {
    id: "source17",
    heading: "Track20 FP Spending Assessments",
    content: `<p>FP Spending Assessments conducted by Track20 in Indonesia, Bangladesh, Kenya and Senegal provide estimates of Government expenditures.</p>`
  },
  {
    id: "source16",
    heading: "RHSC LAC Country Survey",
    content: `<p>RHSC Survey conducted in Honduras, El Salvador, Guatemala, Nicaragua, Mexico, Paraguay, Bolivia, Peru provide estimates of government expenditures.</p>`
  },
  {
    id: "source18",
    heading: "NIDI Resource Flows",
    content: `<p>Supported by UNFPA and conducted by NIDI, <a href="http://www.resourceflowsdata.org/">these reports</a> provide estimates of government expenditures.</p>`
  },
  {
    id: "source19",
    heading: "UNFPA Report on Government Spending",
    content: `<p>Data collected by UNFPA Country Offices on Government Allocations and Spending informs estimates of government expenditures.</p>`
  },
  {
    id: "source20",
    heading: "Contraceptive Security Indicators",
    content: `<p>Published by USAID's Global Health Supply Chain Program, <a href="https://www.ghsupplychain.org/csi-dashboard">this report</a> provides estimates of government spending.</p>`
  },
  {
    id: "source21",
    heading: "CGA Estimates of Consumption Costs",
    content: `<p>CGA 2019 estimates of consumption costs contribute to current spending estimates.</p>`
  }
];
